import { apiClient, adminApiClient } from '../axios.config';
import { API_ENDPOINTS } from '../constants';
import type { ApiResponse } from '../types/common';
import type {
  UserProfile,
  AdminLoginRequest,
  AdminLoginResponse,
} from '../types/auth.types';

/**
 * Auth Service - All authentication-related API calls
 */
export const authService = {
  getUserProfile: async (): Promise<ApiResponse<UserProfile>> => {
    const response = await apiClient.get<ApiResponse<UserProfile>>(
      API_ENDPOINTS.AUTH.USER_PROFILE
    );
    return response.data;
  },

  adminLogin: async (
    payload: AdminLoginRequest
  ): Promise<ApiResponse<AdminLoginResponse>> => {
    const response = await apiClient.post<ApiResponse<AdminLoginResponse>>(
      API_ENDPOINTS.AUTH.ADMIN_LOGIN,
      payload
    );
    return response.data;
  },

  /** Verify admin session (requires admin token) */
  getAdminSession: async (): Promise<ApiResponse<{ role: string; adminId: string }>> => {
    const response = await adminApiClient.get<ApiResponse<{ role: string; adminId: string }>>(
      API_ENDPOINTS.AUTH.ADMIN_ME
    );
    return response.data;
  },
};
